{
  "assets": {
    "upload_new": "Neues {{ assetType }} hochladen"
  },
  "edit_layer": {
    "discard_title": "Ungespeicherte Änderungen",
    "discard_message": "Wenn Sie auf Ja klicken, erklären Sie sich damit einverstanden, alle ungespeicherten Änderungen an dieser Ebene zu verwerfen. Möchten Sie trotzdem fortfahren?"
  },
  "move": {
    "moveTo": "Gehen Sie zu diesem Ort",
    "setTo": "Neuen Standort festlegen",
    "tooltip": {
      "Map": "Kann nicht in einen Plan wechseln",
      "Layer": "Kann nicht in eine Ebene wechseln"
    },
    "tooltip_self": "Ein Ordner kann nicht in sich selbst verschoben werden"
  },
  "fixed_shape": {
    "length": "Länge",
    "width": "Breite"
  },
  "mapObjectSidebarOptions": {
    "hide_object": "Objekt ausblenden",
    "show_object": "Objekt einblenden",
    "hide_group": "Gruppe ausblenden",
    "show_group": "Gruppe einblenden"
  },
  "object_details": {
    "minimise": "Objektdetails minimieren",
    "edit_attributes": "Attribute verwalten",
    "object_details": "OBJEKTDETAILS",
    "object_name": "Name des Objekts"
  },
  "verticalBarErrors": {
    "layer_hidden_drawing": "Eine Ebene, die ausgeblendet ist, kann nicht bearbeitet werden",
    "layer_locked_drawing": "Eine gesperrte Ebene kann nicht bearbeitet werden",
    "hide_layer_composition": "Sie können eine Ebene nicht ausblenden, während Sie sie bearbeiten",
    "group_composition": "Sie können eine Gruppe nicht ausblenden, während Sie eine ihrer Ebenen bearbeiten"
  },
  "export_map": {
    "export_map": "Plan exportieren",
    "export_preview": "Vorschau exportieren",
    "lock_map": "Darstellungsfenster sperren",
    "orientation": {
      "title": "Ausrichtung der Seite",
      "portrait": "Portrait",
      "landscape": "Landschaft"
    },
    "page_size": {
      "title": "Größe der Seite"
    },
    "file_format": {
      "title": "Format der Datei"
    },
    "scale": "Skalieren",
    "infoTooltip": {
      "title": "Darstellungsfenster",
      "text": "Klicken Sie auf die Karte, um zu scrollen und Ihren Viewport anzupassen. Sperren Sie dann den Viewport, um die Änderungen in Ihrem Editor zu speichern."
    },
    "positionMapOverlay": {
      "title": "Positionieren Sie die Karte",
      "text": "Schwenken, Zoomen und Drehen, um den zu exportierenden Bereich auszuwählen"
    },
    "read_user_visibility_warning": "Bei Exporten werden Sichtbarkeitsänderungen von Benutzern ohne Vollzugriff auf die Karte ausgeschlossen."
  },
  "styles": {
    "customiseColour": "Farbe anpassen",
    "scaleText": "Skalieren Sie das Symbol an den Text",
    "textMargin": "Textrand",
    "modelVariableSizeError": "Ungültiger Wert. Bitte stellen Sie sicher, dass alle Werte zwischen {{ minValue }} und {{ maxValue }} liegen",
    "dimensions": "Abmessungen",
    "customDimensions": "Passen Sie die Abmessungen der Modelle an",
    "customColour": "Erlaube benutzerdefinierte Farben.",
    "customImage": "Benutzerdefiniertes Bild zulassen (Seitenverhältnis optional).",
    "widthLengthHeight": "Breite, Länge, Höhe"
  },
  "permissions": {
    "permission_is": "Die Erlaubnis ist",
    "readonly": "nur lesbar",
    "map": "auf einem Plan",
    "layer": "auf einer Ebene",
    "selection": "auf Auswahl"
  },
  "layer_overflow": {
    "hidden_text": "Menü „Ebenenüberlauf“",
    "layer_properties": "Ebenen-Einstellungen",
    "attribute_table": "Attributtabelle",
    "delete_layer": "Ebene löschen",
    "layer_view": {
      "display_text": "Ebenenansicht",
      "view_by_object": "Ansicht nach Objekt",
      "view_by_attribute": "Nach Attribut anzeigen"
    },
    "remove_from_map": "Aus dem Plan entfernen",
    "manage_permissions": "Berechtigungen verwalten"
  },
  "plan": "Pläne",
  "dashboard": "Armaturenbrett",
  "units": {
    "feet": "Füße"
  },
  "controls": {
    "set_pitch": "Kippen Sie die Ansicht"
  },
  "toolbarButtonTooltips": {
    "helpButton": "Hilfe",
    "layers": "Zurück zu den Ebenen"
  }
}